import React from 'react';
import './Information.style.css';

const Information = ({
  title = '안내',
  content = [],
  direction = 'row',
  style = {},
  titleStyle = {},
  contentStyle = {},
}) => {
  /* ===== Route ===== */
  /* ===== Props ===== */
  /* ===== State ===== */
  /* ===== Hooks ===== */
  /* ===== Function ===== */
  /* ===== Variable ===== */
  /* ===== Hooks ===== */
  /* ===== Render ===== */
  return (
    <div className="infomation_wrapper" style={{ ...style }}>
      <div
        className="infomation_container"
        style={{
          flexDirection: direction,
          alignItems: direction === 'row' ? 'center' : 'flex-start',
        }}
      >
        <div>
          <h5 style={{ ...titleStyle }}>{title}</h5>
        </div>
        <ul>
          {content.map((_item, _index) => (
            <li key={`info_${_index}`} style={{ ...contentStyle }}>
              <span>{_index + 1}.</span>
              <p>{_item}</p>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Information;
